import { render } from "./delivery-time.vue?vue&type=template&id=2d6e56a0"
import script from "./delivery-time.vue?vue&type=script&lang=js"
export * from "./delivery-time.vue?vue&type=script&lang=js"

import "./delivery-time.vue?vue&type=style&index=0&id=2d6e56a0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__